import Vue from 'vue'
import PrismicVue from 'prismic-vue'
import linkResolver from './prismic/link-resolver'
import htmlSerializer from './prismic/html-serializer'
import App from './App.vue'
import router from './router'
import VueSimpleSVG from 'vue-simple-svg'
import checkView from 'vue-check-view'
import VModal from 'vue-js-modal'
 
Vue.use(VModal)
Vue.use(checkView)
Vue.use(VueSimpleSVG)

Vue.config.productionTip = false

Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
  htmlSerializer
})

let globalData = new Vue({
  data: { KriensTourismus: window.KriensTourismus }
})

Vue.mixin({
  computed: {
    KriensTourismus: {
      get: function () { return globalData.$data.KriensTourismus },
      set: function (newData) { globalData.$data.KriensTourismus = newData }
    }
  }
})


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
